import api from './api'

export default {
  async getByDate(date) {
    const { data } = await api.get('/attendance', { params: { date } })
    return data
  },
  async markAttendance(record) {
    const { data } = await api.post('/attendance', record)
    return data
  },
  async updateAttendance(id, record) {
    const { data } = await api.put(`/attendance/${id}`, record)
    return data
  },
  async getDailyStats(date) {
    const { data } = await api.get('/attendance/stats', { params: { date } })
    return data
  }
} 